import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import {
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Drawer,
  IconButton,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AbcIcon from "@mui/icons-material/Abc";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link as RouterLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

export const GetStartedPage = (props) => {
  const [open, setOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState(true);

  const [menu, setMenu] = useState(false);

  return (
    <div className="get-started-page">
      <header className="topbar">
        <IconButton
          className="menu-button"
          onClick={() => {
            setMenu(true);
          }}
        >
          <MenuIcon />
        </IconButton>
        <div className="topbar-logo">
          <a href="https://www.fabloq.com">
            <div class="surface">
              <p class="f-letter">F</p>
              <div class="block"></div>
            </div>
          </a>
        </div>
        <span className="topbar-docs">Docs</span>
      </header>

      <main className="content">
        <Drawer
          open={menu}
          onClose={() => {
            setMenu(false);
          }}
          className="drawer"
        >
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </Drawer>
        <div className="sidebar" style={{ height: window.innerHeight - 55 }}>
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </div>
        <div className="article">
          <div className="article-left" />
          <div className="article-content">
            <h2 className="topic-title" id="introduction">
              <span className="hashtag">#</span> Introduction
            </h2>
            <p className="topic-para">
              Fabloq is a no-code API builder that you can use to build APIs for
              your projects quickly; further, you do not have to look for
              hosting and domain to start using it.<br></br>Once you build your
              API in Fabloq you can directly start using it. Fabloq provides you
              with different “blocks” with different functionalities like
              control logic, database calls, and authentication. You can join
              these blocks to create different programs for your API endpoints.
              <br></br>Whether you are a frontend developer looking to build a
              backend for your app, an IoT engineer who wants to build an API
              for your automation project or a Full-stack developer who wants to
              quickly build, test and deploy your backend, Fabloq will fulfil
              your objectives.<br></br>Happy Building 🛠️
            </p>
            <h2 className="topic-title" id="create-new-project">
              <span className="hashtag">#</span> Create new project
            </h2>
            <p className="topic-para">
              To create your first project in Fabloq, login in your Fabloq
              account. Once you reach Projects page select “Create New Project”.
              Once you create your project you will presented with workspace for
              your project.
            </p>
            <img
              src="images/get-started/project-page.png"
              alt="Myu Projects Page"
              className="topic-image"
            />
            <h2 className="topic-title" id="create-new-endpoint">
              <span className="hashtag">#</span> Create new endpoint
            </h2>
            <p className="topic-para">
              On your project workspace page select plus button under the
              Endpoints menu in the sidebar.
            </p>
            <img
              src="images/get-started/workspace-page.png"
              alt="Myu Projects Page"
              className="topic-image"
            />
            <p className="topic-para">
              In the endpoint dialog box enter a recognisable name for your
              endpoint. Select an HTTP protocol depending on your need.
            </p>
            <ol>
              <li className="topic-para">
                <span className="topic-para-bold">GET:</span> Fetch data from
                the API.
              </li>
              <li className="topic-para">
                <span className="topic-para-bold">POST:</span> Send data to the
                API.
              </li>
              <li className="topic-para">
                <span className="topic-para-bold">PUT:</span> Update data on the
                API.
              </li>
              <li className="topic-para">
                <span className="topic-para-bold">DELETE:</span> Delete data on
                the API.
              </li>
            </ol>
            <p className="topic-para">
              After that enter a path for your endpoint. E.g.: name/, getage/.
              And select Create.
            </p>
            <div className="topic-para-note">
              <p className="topic-para">
                <span className="topic-para-bold">NOTE:</span> Path can contain
                characters 0-9, a-z, A-Z, / and -
              </p>
            </div>
            <h2 className="topic-title" id="build-endpoint">
              <span className="hashtag">#</span> Build endpoint
            </h2>
            <p className="topic-para">
              Click on plus icon at the center of workspace to start adding
              blocks to endpoint. Head over to the Blocks section to learn about
              different blocks and their functions.
            </p>
            <h2 className="topic-title" id="examples">
              <span className="hashtag">#</span> Examples
            </h2>
            <div className="video-container">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/foCH0x0ehTo?si=dvQUcc4E-hTXoAod"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
            <div className="topic-footline"></div>
            <div className="topic-buttons">
              <div />
              <Button component={RouterLink} to="/blocks/overview">
                Blocks - Overview <ChevronRightIcon />
              </Button>
            </div>
          </div>
          <div className="article-right" />
        </div>
        <div className="index">
          <a className="index-title">Contents</a>
          <a className="index-topic" href="#introduction">
            Introduction
          </a>
          <a className="index-topic" href="#create-new-project">
            Create new project
          </a>
          <a className="index-topic" href="#create-new-endpoint">
            Create new endpoint
          </a>
          <a className="index-topic" href="#build-endpoint">
            Build endpoint
          </a>
          <a className="index-topic" href="#examples">
            Examples
          </a>
          {/* <div className="index-sublist">
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
            </div> */}
        </div>
      </main>
    </div>
  );
};
